module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/premiumheader.9775bd8.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/premiumheader.png
// module id = 2PM9
// module chunks = 41